export default __webpack_public_path__ + "static/media/orphan-swords.0861e955.jpg";